import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { TransactionSubType } from 'src/model/transactionSubType.model';
import { TransactionType } from 'src/model/transactionType.model';

@Component({
    selector: 'app-add-subtype',
    templateUrl: './add-subtype.component.html',
    styleUrls: ['./add-subtype.component.scss'],
    standalone: false
})

export class AddSubtypeComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private sharedService = inject(SharedService);

  subtypeList: TransactionSubType[] = [];
  transactionTypeList: TransactionType[] = [];

  //2 way binding variables
  name: string;
  selectedTransactionType: number;

  ngOnInit(): void {
    this.getTransactionType();
    this.getTransactionSubTypes();
  }

  getTransactionType() {
    const xhttp = this.restapi.getRequest(this.constructApi.getAllTransactionTypes());
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const type = new TransactionType(json.id, json.name);

          this.transactionTypeList.push(type);
        });

        this.transactionTypeList.sort((a, b) => ((a.ID > b.ID)) ? 1 : -1);
      }
    };
  }

  getTransactionSubTypes() {
    const xhttp = this.restapi.getRequest(this.constructApi.getAllTransactionSubTypes());
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const type = new TransactionSubType(json.id, json.name, json.type, json.assignable, json.enabled);

          this.subtypeList.push(type);
        });
      }
    };
  }

  isInvalid() {
    return this.name == undefined || this.selectedTransactionType == undefined;
  }

  submit() {
    this.isInvalid() ? this.sharedService.openAlert('Please fill in all the fields!', ALERT_TYPE.DANGER) : this.addSubType();
  }

  addSubType() {
    const data = {
      "name": this.name,
      "type": this.selectedTransactionType
    };
    const xhr = this.restapi.postRequest(this.constructApi.getAddTransactionSubType(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        const json = JSON.parse(xhr.responseText);
        const type = new TransactionSubType(json.id, json.name, json.type, json.assignable, json.enabled);

        this.subtypeList = this.subtypeList.concat(type);

        this.resetValues();
      }
    }
  }

  reset() {
    this.activeModal.close();
    this.resetValues();
  }

  resetValues() {
    this.name = undefined;
    this.selectedTransactionType = undefined;
  }

  openDeleteConfirmationDialog(subType: TransactionSubType) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to delete " + subType.Name + " ?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.deleteScheme(subType);
    });
  }

  deleteScheme(subType: TransactionSubType) {
    const xhttp = this.restapi.deleteRequest(this.constructApi.getDeleteTransactionSubType(subType.ID));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        for (const i in this.subtypeList) {
          if (this.subtypeList[i].ID == subType.ID) {
            this.subtypeList.splice(Number(i), 1);
            this.cdr.detectChanges();
          }
        }
      }
    };
  }
}
